import cx from 'classnames';
import { func } from 'prop-types';
import React from 'react';

import { ReactComponent as SmartbeLogo } from '../../assets/smartbe_logo.svg';
import Button from '../../components/Button';
import useWindowSize from '../../utils/useWindowSize';

import s from './index.module.css';


const Header = ({ onBtnClick }) => {
  const windowSize = useWindowSize();
  const isHighlightFirst = windowSize.width < 558 && windowSize.width >= 370;

  return (
    <header className={s.appHeader}>
      <div className={s.headerContent}>
        <section className={s.leftSection}>
          <a className={s.headerLogoLink} href="/">
            <SmartbeLogo className={s.smartbeLogo} />
          </a>
          <h1 className={s.sectionHeader}>
            Удаленная работа для
            {isHighlightFirst && <br />}
            <span className={cx(s.highlightedText, { [s.firstWord]: isHighlightFirst })}>
              экспертов
            </span>
            <span className={s.endText}>в запчастях</span>
          </h1>
          <p className={s.sectionDescription}>Докажите, что разбираетесь в&nbsp;запчастях и получите первое вознаграждение уже сегодня</p>
          <div className={s.btnWrapper}>
            <Button className={s.submitBtn} type="button" onClick={onBtnClick}>Начать зарабатывать</Button>
          </div>
        </section>
      </div>
      <div className={s.headerBanner}></div>
    </header>
  );
}

Header.propTypes = {
  onBtnClick: func,
};

Header.defaultProps = {
  onBtnClick: () => {},
};

export default Header;
